import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  VOICE_REVENUE_RATE_CHARACTERS,
  VOICE_REVENUE_RATE_AMOUNT,
} from '@src/constants/withdrawal';
import i18n from '@src/languages';
import sanitizeHtml from 'sanitize-html';
import { getPriceText } from '@src/services/payment';
import { COLOR } from '@src/styles/color';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import SubjectRoundedIcon from '@mui/icons-material/SubjectRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import SummaryCard from './SummaryCard';
import { StyledSummary } from './index.style';

const Summary = ({ summaryData }) => {
  const { t } = useTranslation();
  const { language } = i18n;

  const {
    totalCommunityVoice = 0,
    totalUsers = 0,
    totalCredits = 0,
    totalMoneyVnd = 0,
  } = summaryData || {};

  const cardsData = [
    {
      title: t('totalPublicVoice'),
      value: `${totalCommunityVoice?.toLocaleString(language)}`,
      icon: (
        <RecordVoiceOverRoundedIcon
          sx={{ fontSize: '24px', color: COLOR.navyBlue }}
        />
      ),
    },
    {
      title: t('totalUsersUsed'),
      value: `${totalUsers?.toLocaleString(language)}`,
      icon: (
        <GroupsRoundedIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
      ),
    },
    {
      title: t('totalCharactersConverted'),
      value: `${totalCredits?.toLocaleString(language)}`,
      icon: (
        <SubjectRoundedIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
      ),
    },
    {
      title: t('totalRevenue'),
      value: `${totalMoneyVnd?.toLocaleString(language)}`,
      icon: (
        <MonetizationOnRoundedIcon
          sx={{ fontSize: '24px', color: COLOR.navyBlue }}
        />
      ),
      showTooltip: true,
      titleTooltip: (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              t('eachCharactersConverted', {
                characters:
                  VOICE_REVENUE_RATE_CHARACTERS.toLocaleString(language),
                revenue: getPriceText(
                  VOICE_REVENUE_RATE_AMOUNT.toLocaleString(language),
                  true,
                  language,
                ),
              }),
              {
                allowedTags: ['strong', 'span', 'br'],
                allowedAttributes: {
                  '*': ['style'],
                },
              },
            ),
          }}
        />
      ),
      showUnit: true,
      appDetail: false,
    },
  ];
  return (
    <StyledSummary>
      {cardsData.map((card) => (
        <SummaryCard key={card.title} {...card} />
      ))}
    </StyledSummary>
  );
};

export default Summary;
